<template>
  <div class="cuotiben_Warp">
    <COMMONTOPSEARCH ref="commonTopSearchRef"
                     @initData="getPaperList"
                     :showSearch="false" />
                       <!-- 下拉选择框 -->
                       <div class="explain"><img src="@/static/error_book/circle.png" alt=""/>本功能根据最新名校模拟题中考点出现频次进行计算，内容实时变动，越接近中考，预测越精准哦！</div>
    <div class="select_subject">
      <dropDown :list='typeList'
                :index='idx'
                attribute_name='name'
                @changeMenu='checkOneChapter' />
    </div>
   
    <div class="topic_warp">
      <div class="paper"
      v-if="filteredPaperList.length>0"
           v-for="(item,index) in filteredPaperList"
           :key="index">
        <div class="content_wrap">
          <div class="top">
            <div class="title">
              {{item.knowledge_desc}}
            </div>
            <div class="pl">
              <span style="flex:1">易错指数:<span class="num">{{item.error_prone }}</span></span>

              <span style="flex:1">出现频次:<span class="num">{{item.use_times}}</span></span>

              <!-- <span style="flex:1">
                星级:
              <img src="@/static/zhishidian/xx.jpg"
                   style="width:20rem;height:20rem"
                   v-for="(item,idx) in item.knowledge_point_star"
                   :key="idx" /></span> -->
            </div>
            <div class="pl">
                   <span style="flex:1">掌握情况:<span class="num1"><img v-if="item.score=='暂未练习相关习题'" style="width:32rem;height:32rem" src="@/static/error_book/white.png" alt=""/><img v-if="Number(item.score) >= Number(item.hope_score)" style="width:32rem;height:32rem" src="@/static/error_book/green.png" alt=""/> <img v-if="10 <= Number(item.hope_score) - Number(item.score) && Number(item.score) < Number(item.hope_score)" style="width:32rem;height:32rem" src="@/static/error_book/red.png" alt=""/><img style="width:32rem;height:32rem" v-if="Number(item.hope_score) - Number(item.score) <= 5 && Number(item.score) < Number(item.hope_score)" src="@/static/error_book/orange.png" alt=""/>{{getMasteryStatus(item.hope_score,item.score) }}</span></span>
            </div>
           
          </div>
          <div class="btn">
            <button @click="showOtherSecond(item)"
                    v-show="item.child&&item.child.length>0">
                    二级/三级考点
            </button>
          
            <button @click="showOther(item)"
                    v-show="item.videos&&item.videos.length>0&&show_video">
              考点讲解
            </button>
              <button @click="viewLecture(item)"
                    v-show="item.lecture_data&&item.lecture_data.length>0">
              查看讲义
            </button>
            <button @click="toDopaper(item)">
              进入训练
            </button>
          </div>
        </div>

      </div>
      <div v-if="!loading &&filteredPaperList.length==0"
         class="its"
         > 暂无数据</div>
    </div>
    <OtherForm ref="otherFormRef" />
    <OtherFormSecond ref="otherFormSecondRef" />
    <OtherFormThird ref="otherFormThirdRef" />
    <LectureForm ref="LectureFormRef" />
  </div>
</template>

<script setup>
import COMMONTOPSEARCH from '@/views/components/COMMON_TOP_SEARCH/index.vue'
import OtherForm from './components/other.vue'
import LectureForm from './components/lecture.vue'
import OtherFormSecond from './components/otherFormSecond.vue'
import OtherFormThird from './components/otherFormThird.vue'
import dropDown from './components/index.vue'
import { ref ,reactive} from '@vue/reactivity'
import { getPredictList } from '@/api/errorBook.js'
import { message } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import { computed, onMounted } from "@vue/runtime-core";


const router = useRouter()
let paperList = ref([])
let subject_id = ref('')
let idx = ref(0)
const otherFormRef = ref(null)
const otherFormSecondRef = ref(null)
const otherFormThirdRef = ref(null)
const LectureFormRef = ref(null)
let show_video = ref(null)
let loading = ref(false)

let typeList = [
{ name: '全部', value: '4' },
{ name: '已达标', value: '0' },
  { name: '快达标', value: '1' },
  { name: '未达标', value: '2' },
  { name: '未训练', value: '3' }
]
onMounted(() => {
  show_video.value = JSON.parse(window.localStorage.getItem('userInfo')).show_video
 
})


const  getMasteryStatus = (hope_score,score)=> {
      if (Number(score) >= Number(hope_score)) {
        return '已达标';
      } else if (Number(hope_score) - Number(score) <= 5 && Number(score) < Number(hope_score)) {
        return '快达标';
      } else if (10 <= Number(hope_score) - Number(score) && Number(score) < Number(hope_score)) {
        return '未达标';
      } else {
        return '未训练';
      }
    }
    const  getMasteryIcon = (hope_score,score)=> {
      if (Number(score) >= Number(hope_score)) {
        return '@/static/error_book/green.png';
      } else if (Number(hope_score) - Number(score) <= 5 && Number(score) < Number(hope_score)) {
        return '@/static/error_book/orange.png';
      } else if (10 <= Number(hope_score) - Number(score) && Number(score) < Number(hope_score)) {
        return '@/static/error_book/red.png';
      } else {
        return '@/static/error_book/white.png';
      }
    }
    const filteredPaperList = computed(() => {
    const currentIndex = idx.value;
    console.log('cc',currentIndex)
    return paperList.value.filter(item => {
        if (currentIndex == 1) {
            return Number(item.score) >= Number(item.hope_score);
        } else if (currentIndex == 2) {
            return Number(item.hope_score) - Number(item.score) <= 5 && Number(item.score) < Number(item.hope_score);
        } else if (currentIndex == 3) {
            return 10 <= Number(item.hope_score) - Number(item.score) && Number(item.score) < Number(item.hope_score);
        } else if(currentIndex == 4) {
            return item.score == '暂未练习相关习题';
        }else{
          return item;
        }

    });

});
const checkOneChapter = (index) => {
  idx.value = index
 
}
const getPaperList = async (id, keywords) => {
  loading.value = true
  let params = {
    subject_id: id,
    platform: 1,
    uid: JSON.parse(window.localStorage.getItem('userInfo')).user_id,
  }
  const { data } = await getPredictList(params)
  subject_id.value = id
  paperList.value = data.map(item => {
    item.knowledge_point_frequency = item.knowledge_point_frequency.toFixed(2)
    return item
  })
  loading.value = false
}
const viewLecture = (item) => {
  LectureFormRef.value.list = item.lecture_data
  LectureFormRef.value.dialogVisible = true
}
const showOther = (item) => {
  // if (!item.child || item.child.length == 0) {
  //   message.warning('该条目涉及题目暂时较少，请返回上一级训练')
  //   return
  // }
  // item.child.map(item => {
  //   item.active = false
  //   return item
  // })
  // otherFormRef.value.subjectId = item.subject_id
  otherFormRef.value.list = item.videos
  otherFormRef.value.dialogVisible = true
}
const showOtherThird = (item) => {
  if (!item.child || item.child.length == 0) {
    message.warning('该条目涉及题目暂时较少，请返回上一级训练')
    return
  }
  // item.child.map(item => {
  //   item.active = false
  //   return item
  // })
  const allChildren = item.child.flatMap(childItem => childItem.child || []);
  if (allChildren.length == 0) {
    message.warning('暂无三级考点')
    return
  }

  otherFormThirdRef.value.subjectId = item.subject_id
  otherFormThirdRef.value.list = allChildren
  otherFormThirdRef.value.dialogVisible = true
}
const showOtherSecond = (item) => {
  if (!item.child || item.child.length == 0) {
    message.warning('该条目涉及题目暂时较少，请返回上一级训练')
    return
  }
  item.child.map(item => {
    item.active = false
    return item
  })
  otherFormSecondRef.value.subjectId = item.subject_id
  otherFormSecondRef.value.list = item.child
  otherFormSecondRef.value.dialogVisible = true
}


const toDopaper = (item) => {
  let form = {
    subject_id: subject_id.value,
    knowledge_id: item.knowledge_id
  }
  window.sessionStorage.removeItem('testpaperCardIndex')
  window.sessionStorage.removeItem('paper')
  router.push('/doPaper?isKnowledge=1&form=' + JSON.stringify(form))          
}


</script>

<style lang="scss" scoped>
.select_subject {
  position: absolute;
  top: 30rem;
  right: 40rem;
  background: #303fd4;
  border-radius: 35rem;

  /* .mock_btn {
    width: 240rem;
    height: 60rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 32rem;
    font-weight: 500;

    img {
      width: 26rem;
      height: 26rem;
      margin-left: 12rem;
    }
  }*/
}
.cuotiben_Warp {
  overflow: hidden;
  overflow-y: auto;  
  width: 100%;
  height: 100vh;
  background-image: url("../../static/allBackg/bg-预测.png");  
  background-repeat: no-repeat;
  background-size: 100% 100%;
 ::v-deep .subjectabs{
  margin-top:38rem
 }
 .explain{
  display: flex;
    justify-content: center;
    color: var(--dark-100-ffffff, #FFF);
align-items: center;
font-size: 24rem;
font-style: normal;
font-weight: 400;
line-height: 36rem; 
    position: absolute;
    top: 78rem;
    left:415rem
 }
  .topic_warp {
    width: calc(100vw - 240rem);
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    overflow-y: auto;
    margin: 0 auto;
    margin-top: 10rem;
    padding-bottom: 20rem;
    height: calc(100vh - 210rem);
    .its {
  overflow: hidden;
  color: var(--light-ffffff, #fff);
  text-overflow: ellipsis;
  font-size: 28rem;
  font-style: normal;
  font-weight: 400;
  margin-left:800rem;
margin-top: 200rem;
  line-height: 42rem; /* 150% */
}
    .paper {
      width: 510rem;
      height: 220rem;
      background: #b29bfa;
      border-radius: 20rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 28rem;
      // margin-bottom: 20rem;
      margin-top: 30rem;
      &:hover {
        .content_wrap {
          height: auto;
          .top {
            height: auto;
            .title {
              display: block;
              height: auto;
              min-height: 40rem;
              font-size: 28rem;
            }
          }
        }
      }
      .content_wrap {
        width: 490rem;
        height: 200rem;
        box-shadow: 0rem 2rem 8rem 0rem rgba(98, 47, 215, 1);
        overflow: hidden;
        border-radius: 20rem;
        .top {
          height: 146rem;
          background: white;
          padding: 16rem;
          .title {
            font-size: 28rem;
            font-weight: bold;
            color: #000000;
            overflow: hidden;
            height: 40rem;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .pl {
            font-size: 22rem;
            line-height: 40rem;
            font-weight: 500;
            color: #999999;
            display: flex;
            align-items: center;
          }
          .num {
            color: #FB9930;
          }
          .num1 {
            color: #333;
          }
        }
        .btn {
          display: flex;
          height: 54rem;
          justify-content: center;
          align-items: center;
          box-shadow: 0rem 2rem 8rem 0rem rgba(98, 47, 215, 1);
          background: #a68cf3;

          button {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1 1 auto;
            height: 30rem;
            text-align: center;
            font-size: 22rem;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
            background: transparent;
            border: 0;
            // &:nth-child(1) {
            border-right: 2rem solid rgba(255, 255, 255, 0.5);
            // }
          }
        }
      }
    }
  }
}
// .active {
//   font-weight: bold;
//   color: white !important;
// }
::-webkit-scrollbar-thumb {
  background-color: hsla(217, 100%, 87%, 0.5);
}
</style>
